import { ConfigProvider } from 'antd';
import 'antd/dist/reset.css';
import zhCN from 'antd/locale/zh_CN';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './auth/AuthContext';
import RequireAuth from './auth/RequireAuth';
import Layout from './components/Layout';
import ContentManagement from './pages/ContentManagement';
import AccountManagement from './pages/AccountManagement';
import TimedPublish from './pages/TimedPublish';
import Billing from './pages/Billing';
import LandingPage from './pages/LandingPage';
import ContentProduce from './pages/ContentProduce';
import AgentSetup from './pages/AgentSetup';
import Statistics from './pages/Statistics';

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LandingPage />} />
            <Route
              element={(
                <RequireAuth>
                  <Layout />
                </RequireAuth>
              )}
            >
              <Route path="/content" element={<ContentManagement />} />
              <Route path="/produce" element={<ContentProduce />} />
              <Route path="/timedPublish" element={<TimedPublish />} />
              <Route path="/statistics" element={<Statistics />} />
              <Route path="/users" element={<AccountManagement />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/agent/setup" element={<AgentSetup />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
